export default class QuestionChoiceDTO {
  constructor(item = {}) {
    this.id = item.id;
    this.title= item.title;
    this.isRight = item.is_right;
    this.ordering = item.ordering;
    this.picture = item.picture;
  }
}